import React from 'react'
import Icon from 'components/Icon'
import styles from './SearchBar.scss'
import Button from 'components/Button'

interface ISearchBar {
  searchValue: string
  setSearchValue: React.Dispatch<React.SetStateAction<string>>
  placeholder?: string
}

const SearchBar = ({ searchValue, placeholder, setSearchValue }: ISearchBar) => {
  return (
    <div className={styles.container}>
      <Button buttonType='secondary-icon' disabled className={styles.searchButton}>
        <Icon size='standard' name='search-lg-grey' />
      </Button>
      <input
        type='text'
        className={styles.input}
        placeholder={placeholder || 'Search'}
        value={searchValue}
        onChange={e => setSearchValue(e.target.value)}
      />
    </div>
  )
}

export default SearchBar
